import React, { useState, Fragment } from 'react';
import { classNames } from '../../../Services/helpers';
import Markdown from '../../../Components/Formatting/Markdown';
import TimeAgo from '../../../Components/Formatting/TimeAgo';
import Preview from '../../../Components/Gallery/Preview';
import Icon from '../../../Components/Icons/Icon';

const Entries = ({entries, files}) => {
    return <div className="flex flex-col gap-2">
        {entries?.map((entry, index) => {

            if (entry.type === 'assistantError') {
                return <ErrorMessage key={index} entry={entry} />
            }

            if (entry.type === 'assistantActivated' || entry.type === 'assistantDeactivated') {
                return <SystemMessage key={index}
                    message={
                        entry.type === 'assistantActivated' ?
                            'Sid has joined the conversation' :
                            'Sid has left the conversation'
                        }
                />
            }

            if (entry.type === 'humanAttentionRequested' || entry.type === 'humanAttentionRemoved') {
                return <SystemMessage key={index}
                    message={
                        entry.type === 'humanAttentionRequested' ?
                            'The conversation has been flagged for human attention' :
                            null
                        }
                />
            }

            if (!entry.message || entry.role === 'system') {
                return <SystemEntry key={index} entry={entry} />
            }

            return <Fragment key={index}>
                    <div className={classNames(
                    'p-3 rounded-lg max-w-[90%]',
                    entry.role === 'User' ? 'bg-slate-100 dark:bg-slate-700 dark:text-slate-200 rounded-bl-none self-start' : 'bg-sky-100 dark:bg-sky-700 dark:text-slate-200 rounded-br-none self-end',
                    entry.role === 'AdminPrivate' && 'border border-slate-300 dark:border-slate-600 bg-slate-50 dark:bg-slate-800/50',
                )}>
                    <div className="text-xs text-muted mb-1">
                        {entry.role === 'AdminPrivate' ? (
                            <span className="flex items-center gap-1">
                                <Icon icon="Lock" theme="solid" size="0.5x" className="fill-slate-400 dark:fill-slate-500" />
                                Private
                            </span>
                        ) : entry.role}
                        <TimeAgo dateTime={entry.addedAt} className="pl-5 float-right" />
                    </div>
                    <Markdown markdown={entry.message}
                        className="[&>:first-child]:mt-0 [&>:last-child]:mb-0"
                        files={files}
                    />
                </div>
                {entry.assetIds && <Preview assetIds={entry.assetIds} align={entry.role === 'User' ? 'left' : 'right'} />}
            </Fragment>
        })}
    </div>
}

export default Entries;

const SystemMessage = ({message}) => {
    if (!message) {
        return null;
    }

    return <p className={classNames(
        'my-0 max-w-[80%] p-2 rounded-lg',
        'self-center bg-slate-50 dark:bg-slate-800 text-muted italic text-center text-balance',
    )}>
        {message}
    </p>
}

const ErrorMessage = ({entry}) => {
    return <div className={classNames(
        'my-0 max-w-[80%] p-2 rounded-lg',
        'self-center bg-red-100 dark:bg-red-900 text-red-900 dark:text-red-100 text-center text-balance',
    )}>
        <p className="text-xs">
            Sid failed to reply
            <TimeAgo dateTime={entry.addedAt} className="pl-2" />
        </p>
        <p className="mb-0">
            {entry.message}
        </p>
    </div>
}

const SystemEntry = ({entry}) => {
    const [open, setOpen] = useState(false);

    return <div className={classNames(
        'my-0 px-2 rounded-lg',
        'transition-all duration-300',
        'self-center bg-orange-100 dark:bg-orange-900 text-muted prose-gray',
        open ? 'w-[80%]' : 'max-w-[80%]'
    )}>
        <p className="text-xs text-muted cursor-pointer capitalize" onClick={() => setOpen(!open)}>
            {entry.type}
        </p>
        {open && <pre className="text-left whitespace-pre-wrap break-words">{JSON.stringify(entry.actions, null, 4)}</pre>}
    </div>
}
